'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcTree = require('./rc-tree');

var _rcTree2 = _interopRequireDefault(_rcTree);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var Tree = (_temp = _class = function (_U$BaseComponent) {
  _inherits(Tree, _U$BaseComponent);

  function Tree(props) {
    _classCallCheck(this, Tree);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Tree).call(this, props));

    _this.resolveRelationship(_this.props);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(_this.props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var k = _step.value;

        if (k.indexOf('Key') !== -1) {
          console.error('方法 ' + k + ' 已经废弃，请立即迁移到 ' + k.replace('Key', 'Id') + ' 方法');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _this;
  }

  _createClass(Tree, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.resolveRelationship(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var data = _props.data;
      var prefixCls = _props.prefixCls;
      var checkable = _props.checkable;
      var onExpand = _props.onExpand;
      var loadData = _props.loadData;

      if (data == null || data.length === 0) return null;
      return _react2.default.createElement(_rcTree2.default, _extends({}, this.props, {
        prefixCls: prefixCls + '-tree',
        checkable: checkable && _react2.default.createElement('span', { className: prefixCls + '-checkbox-inner' }),
        defaultExpandAll: undefined,
        defaultExpandedIds: this.resolveDefaultExpandedIds(),
        loadData: loadData && this.handleLoadData,
        children: this.renderNodes(this.getRootIds())
      }));
    }
  }, {
    key: 'renderNodes',
    value: function renderNodes(nodeIds) {
      var _this2 = this;

      var _props2 = this.props;
      var leafField = _props2.leafField;
      var _props2$format = _props2.format;
      var format = _props2$format === undefined ? Tree.defaultFormat : _props2$format;
      var checkHalfable = _props2.checkHalfable;
      var selectFolderable = _props2.selectFolderable;
      var iconFormat = _props2.iconFormat;

      if (nodeIds.length === 0) return undefined;
      return nodeIds.map(function (nodeId) {
        var node = _this2.getNode(nodeId);
        return _react2.default.createElement(_rcTree2.default.TreeNode, {
          key: nodeId,
          data: node,
          id: nodeId,
          iconFormat: iconFormat,
          title: format(node, _this2),
          disabled: node.disabled,
          disableCheckbox: node.disableCheckbox,
          selectable: (node[leafField] || selectFolderable) && (node.selectable === undefined || node.selectable),
          isLeaf: node[leafField],
          checkHalfable: checkHalfable,
          children: _this2.renderNodes(_this2.getChildIds(nodeId))
        });
      });
    }
  }, {
    key: 'resolveRelationship',
    value: function resolveRelationship(props) {
      var _this3 = this;

      var _ref = props || this.props;

      var data = _ref.data;
      var idField = _ref.idField;
      var leafField = _ref.leafField;
      var parentIdField = _ref.parentIdField;
      var childrenField = _ref.childrenField;
      var resolveRelationship = _ref.resolveRelationship;
      var useTreeData = _ref.useTreeData;

      if (resolveRelationship != null) return resolveRelationship.call(this, props);
      this._nodeMap = {};
      this._rootIdsList = [];
      this._childIdsMap = {};
      this._parentIdMap = {};
      if (useTreeData) {
        var find = function find(nodes) {
          nodes.forEach(function (node) {
            var nodeId = node[idField];
            if (childrenField in node && node[childrenField].length > 0) {
              if (_this3._childIdsMap[nodeId] == null) {
                _this3._childIdsMap[nodeId] = [];
              }
              var childIds = node[childrenField].map(function (v) {
                return v[idField];
              });
              _this3._childIdsMap[nodeId] = childIds;
              childIds.forEach(function (v) {
                _this3._parentIdMap[v] = nodeId;
              });
              find(node[childrenField]);
              node[leafField] = false;
            } else if (!(childrenField in node)) {
              node[leafField] = true;
            }
            _this3._nodeMap[nodeId] = node;
          });
        };
        find(data);
        this._rootIdsList = data.map(function (v) {
          return v[idField];
        });
        return;
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var node = _step2.value;

          var nodeId = node[idField];
          var parentId = node[parentIdField];
          this._nodeMap[nodeId] = node;
          if (this._childIdsMap[parentId] == null) {
            this._childIdsMap[parentId] = [];
          }
          this._childIdsMap[parentId].push(nodeId);
          this._parentIdMap[nodeId] = parentId;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _node = _step3.value;

          var _nodeId = _node[idField];
          var _parentId = _node[parentIdField];
          if (this._nodeMap[_parentId] == null) {
            this._rootIdsList.push(_nodeId);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'resolveDefaultExpandedIds',
    value: function resolveDefaultExpandedIds() {
      var _this4 = this;

      var _props3 = this.props;
      var idField = _props3.idField;
      var defaultExpandAll = _props3.defaultExpandAll;
      var defaultExpandedIds = _props3.defaultExpandedIds;

      if (defaultExpandedIds != null) return defaultExpandedIds;
      if (!defaultExpandAll) return [];
      return Object.values(this._nodeMap).map(function (node) {
        return node[idField];
      }).filter(function (nodeId) {
        return _this4.getChildIds(nodeId).length > 0;
      });
    }
  }, {
    key: 'handleLoadData',
    value: function handleLoadData(node) {
      var nodeId = node.props.id;
      if (this.getChildIds(nodeId).length > 0) return { then: function then() {} }; // FIXME
      var loadData = this.props.loadData;

      return loadData(node.props.id);
    }
  }, {
    key: 'getNode',
    value: function getNode(nodeId) {
      return this._nodeMap[nodeId];
    }
  }, {
    key: 'getRootIds',
    value: function getRootIds() {
      return this._rootIdsList;
    }
  }, {
    key: 'getChildIds',
    value: function getChildIds(nodeId) {
      return this._childIdsMap[nodeId] || [];
    }
  }, {
    key: 'getParentId',
    value: function getParentId(nodeId) {
      return this._parentIdMap[nodeId];
    }
  }], [{
    key: 'defaultFormat',
    value: function defaultFormat(node, tree) {
      var _tree$props = tree.props;
      var idField = _tree$props.idField;
      var showField = _tree$props.showField;

      return showField != null ? node[showField] : node[idField];
    }
  }]);

  return Tree;
}(_util2.default.BaseComponent), _class.defaultProps = {
  prefixCls: 'mt',
  data: [],
  leafField: 'leaf',
  checkable: false,
  selectFolderable: true,
  showIcon: false
}, _temp);

// Tree.propTypes = Object.assign({
//
// }, RcTree.propTypes);

exports.default = Tree;